import { render, staticRenderFns } from "./UploadPage.vue?vue&type=template&id=3924f5d0&scoped=true"
import script from "./UploadPage.vue?vue&type=script&lang=js"
export * from "./UploadPage.vue?vue&type=script&lang=js"
import style0 from "./UploadPage.vue?vue&type=style&index=0&id=3924f5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924f5d0",
  null
  
)

export default component.exports